require("jquery-datetimepicker");

$(function () {
  $(".js-minerva-form-datetimepicker").each(function () {
    $(this).find('input').datetimepicker($.parseJSON($(this).find('script[type="application/json"]').text()));
  });
});



// WEBPACK FOOTER //
// lib/js/minerva-form/datetimepicker.js